import { TextMaskModule } from 'angular2-text-mask';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { SearchboxComponent } from './searchbox/searchbox.component';
import { SublistComponent } from './sublist/sublist.component';
import { HeroComponent } from './hero/hero.component';
import { FigureFullComponent } from './figure-full/figure-full.component';
import { FormCustomComponent } from './form-custom/form-custom.component';
import { RegisterModalComponent } from './register-modal/register-modal.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { GoogleAutocompleteComponent } from './google-autocomplete/google-autocomplete.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ResetPwFormComponent } from './reset-pw-form/reset-pw-form.component';
import { CropImageComponent } from './crop-image/crop-image.component';

@NgModule({
  imports: [
    CommonModule,
    TextMaskModule,
    FormsModule,
    ReactiveFormsModule,
    ImageCropperModule
  ],
  declarations: [
    SublistComponent,
    HeroComponent,
    FigureFullComponent,
    FormCustomComponent,
    RegisterModalComponent,
    SearchboxComponent,
    LoginFormComponent,
    GoogleAutocompleteComponent,
    PaginationComponent,
    ResetPwFormComponent,
    CropImageComponent
  ],
  exports: [
    SublistComponent,
    HeroComponent,
    FigureFullComponent,
    FormCustomComponent,
    RegisterModalComponent,
    SearchboxComponent,
    GoogleAutocompleteComponent,
    PaginationComponent,
    CropImageComponent
  ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/app/components/components.module.ts